<route>
{
  meta: {
    requiresAuth: true
  }
}
</route>
<script setup lang="ts">
/**
 * This is a Vue Component that will be
 * automatically mapped to a entry on vue-router.
 *
 * You will be able to access this page at http://localhost:3000/sidebar-blank-page-2
 * Page uri will match related path to src/pages folder
 *
 * Read more about routing:
 * @see /vite.config.ts
 * @see /src/router.ts
 */

import { useHead } from '@vueuse/head'
import { pageTitle } from '/@src/state/sidebarLayoutState'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { SidebarType } from '/@src/constants'
const route = useRoute()
const router = useRouter()
const { t } = useI18n()

pageTitle.value = 'Dashboard'
useHead({
  title: 'Wisburg 后台管理系统',
})
</script>

<template>
  <SidebarLayout
    theme="curved"
    close-on-change
    :default-sidebar="SidebarType.CONTENT"
  >
    <!-- Content Wrapper -->
    <div class="page-content-inner">
      <!--
          Page content goes here

          You can see pages content samples from
          files in /src/components/pages directory
        -->
      <DashboardHome />
    </div>
  </SidebarLayout>
</template>
